import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FieldForm } from "./forms/FieldForm";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";
import { Link } from "react-router";

export const FieldList = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingField, setEditingField] = useState<Tables<"fields"> | null>(null);

  const { data: fields, isLoading } = useQuery({
    queryKey: ["fields"],
    queryFn: async () => {
      const { data, error } = await supabase.from("fields").select("*").order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <Button onClick={() => setShowForm(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Add Field
        </Button>
      </div>

      {showForm && (
        <FieldForm
          field={editingField}
          onClose={() => {
            setShowForm(false);
            setEditingField(null);
          }}
        />
      )}

      <div className="grid gap-4">
        {fields?.map((field) => (
          <div key={field.id} className="flex items-center justify-between p-4 border rounded-lg">
            <div>
              <h3 className="font-medium">{field.name}</h3>
              <p className="text-sm text-muted-foreground">Type: {field.type}</p>
            </div>
            <div className="flex gap-2">
              <Link to={`/admin/fields/rules?fieldId=${field.id}`}>
                <Button variant="outline" size="sm">
                  Rules
                </Button>
              </Link>
              <Button
                variant="outline"
                onClick={() => {
                  setEditingField(field);
                  setShowForm(true);
                }}
              >
                Edit
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
